import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';
import type { Skill } from './types';

interface UpdateSkillParams {
  skillId: string;
  name?: string;
  description?: string;
}

export const updateSkill = async ({
  skillId,
  name,
  description,
}: UpdateSkillParams): Promise<Skill> => {
  const { currentOrg } = useOrgStore.getState();
  const orgId = currentOrg?.orgid;
  if (!orgId) throw new Error('No organization selected');

  const formData = new FormData();
  if (name !== undefined) formData.append('name', name);
  if (description !== undefined) formData.append('description', description);

  const response = await apiRequest<Skill>({
    url: `/skills/${orgId}/${skillId}`,
    method: 'PUT',
    body: formData,
    formData: true,
    target: 'platform',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) throw new Error('Failed to update skill');
  return response.data;
};
